import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { RouterLink } from 'src/routes/components';

interface ErrorPageProps {
  status?: number;
  message?: string;
  description?: string;
}

function ErrorPage({ status = 500, message, description }: ErrorPageProps) {
  const defaultMessages: Record<number, { title: string; description: string }> = {
    403: {
      title: 'No Permission',
      description: 'The page you’re trying to access has restricted access.',
    },
    404: {
      title: 'Page Not Found',
      description: 'The page you are looking for does not exist or has been moved.',
    },
    500: {
      title: 'Unexpected Application Error',
      description: 'Something went wrong, please try again later.',
    },
  };

  const { title, description: defaultDescription } = defaultMessages[status] || {};
  const finalMessage = message || description || defaultDescription;

  return (
    <Container
      maxWidth="sm"
      sx={{
        height: '100%',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack spacing={4}>
        <Typography
          sx={(theme) => ({ color: theme.palette.grey[200] })}
          fontSize="9.375rem"
          fontWeight={800}
        >
          {status}
        </Typography>

        <Stack spacing={3} alignItems="center">
          <Stack>
            <Typography variant="h6">{title}</Typography>
            <Typography variant="body2" color="text.secondary">
              {finalMessage}
            </Typography>
          </Stack>
          <Button component={RouterLink} variant="contained" href="/" color="primary">
            Go to Home
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
}

export default ErrorPage;
